<div class="content p-5">
  <p class="is-bold is-size-5 color-darkblue has-text-centered">
    Hinweis
  </p>

  <div class="columns">
    <div class="column line-height-is-2">
      <p>Im Bundesland Bayern wird kein Baulastenverzeichnis geführt, daher können wir Ihnen auch keine Auskunft erteilen.</p>

      <p>Sollten Baulasten vorhanden sein, sind diese im Grundbuch in Abteilung II eingetragen.</p>

      <p>Bei weiteren Fragen wenden Sie sich gerne an uns.</p>
    </div>
  </div>

  <div class="columns">
    <div class="column is-one-third"></div>
    <div class="column is-one-third">
      <a class="button buy-button has-round-border" (click)="submitModal()">
        <div class="columns is-align-items-center is-justify-content-center">
          <div class="column is-bold">
            <p class="mb-0">Bestätigen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third"></div>
  </div>
</div>
